var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visibleOnFilter,
          expression: "visibleOnFilter"
        }
      ]
    },
    [
      _c(
        "div",
        {
          staticClass: "ml-0 kanban-card",
          on: {
            click: function($event) {
              return _vm.$emit("openCard", {
                board: _vm.board,
                flow: _vm.flow,
                card: _vm.card
              })
            }
          }
        },
        [
          _vm.state.settings.layout === "list"
            ? _c("div", { staticClass: "row mx-0" }, [
                _vm.state.massSelectionEnabled
                  ? _c(
                      "div",
                      {
                        staticClass: "col pl-0 pr-2",
                        staticStyle: { "flex-grow": "0" }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.state.massSelectionCards,
                              expression: "state.massSelectionCards"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: _vm.card,
                            checked: Array.isArray(_vm.state.massSelectionCards)
                              ? _vm._i(_vm.state.massSelectionCards, _vm.card) >
                                -1
                              : _vm.state.massSelectionCards
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                            },
                            change: function($event) {
                              var $$a = _vm.state.massSelectionCards,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = _vm.card,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.state,
                                      "massSelectionCards",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.state,
                                      "massSelectionCards",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.state, "massSelectionCards", $$c)
                              }
                            }
                          }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "col px-0" }, [
                  _c("div", { staticClass: "row mr-1" }, [
                    _c("div", { staticClass: "col-4 no-overflow" }, [
                      _c("b", [_vm._v(_vm._s(_vm.card.name))]),
                      _vm._v(" "),
                      _vm.isShared
                        ? _c("div", { staticClass: "float-right" }, [
                            _c("i", {
                              staticClass: "fas fa-share",
                              attrs: { title: _vm.$t("txtShared") }
                            })
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-4 no-overflow" }, [
                      _vm.responsible
                        ? _c(
                            "span",
                            { attrs: { title: _vm.$t("txtResponsibles") } },
                            [
                              _c("i", {
                                staticClass: "fa fa-arrow-circle-right",
                                attrs: { "aria-hidden": "true" }
                              }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.responsible) +
                                  "\n            "
                              )
                            ]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        !!_vm.card.activityId
                          ? _c("LinkedActivityCheckableIcon", {
                              staticClass: "mx-2",
                              attrs: {
                                checked: _vm.isActivityClosed(
                                  _vm.card.activityId
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-2" }, [
                      _c("div", { staticClass: "float-right" }, [
                        _c("i", { staticClass: "far fa-check-square" }),
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.createdDate) +
                            "\n            "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mr-1" }, [
                    _c("div", { staticClass: "col-5 no-overflow" }, [
                      _vm._v(_vm._s(_vm.desc))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-5 no-overflow" },
                      [
                        _vm.lastComment
                          ? [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.lastCommentUser +
                                      " (" +
                                      _vm.lastCommentDate +
                                      "): " +
                                      _vm.lastComment
                                  ) +
                                  "\n            "
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-2",
                        style: { color: _vm.dueDateColor }
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.dueDate,
                                expression: "dueDate"
                              }
                            ],
                            staticClass: "float-right"
                          },
                          [
                            _c("i", { staticClass: "far fa-calendar-alt" }),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.dueDate) +
                                "\n            "
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ])
              ])
            : _vm.state.settings.layout === "trello"
            ? _c("div", { staticClass: "row mx-0" }, [
                _vm.state.massSelectionEnabled
                  ? _c(
                      "div",
                      {
                        staticClass: "col pl-0 pr-2",
                        staticStyle: { "flex-grow": "0" }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.state.massSelectionCards,
                              expression: "state.massSelectionCards"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: _vm.card,
                            checked: Array.isArray(_vm.state.massSelectionCards)
                              ? _vm._i(_vm.state.massSelectionCards, _vm.card) >
                                -1
                              : _vm.state.massSelectionCards
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                            },
                            change: function($event) {
                              var $$a = _vm.state.massSelectionCards,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = _vm.card,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.state,
                                      "massSelectionCards",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.state,
                                      "massSelectionCards",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.state, "massSelectionCards", $$c)
                              }
                            }
                          }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "col px-0" }, [
                  _c("div", { staticClass: "row mr-1" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col",
                        staticStyle: { "line-height": "0.75" }
                      },
                      _vm._l(_vm.card.cardLabels, function(cl) {
                        return _c("div", {
                          staticClass: "card-label",
                          style: { "background-color": cl.label.colorTag }
                        })
                      }),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mr-1" }, [
                    _c("div", { staticClass: "col no-overflow" }, [
                      _c("b", [_vm._v(_vm._s(_vm.card.name))]),
                      _vm._v(" "),
                      _vm.isShared
                        ? _c("div", { staticClass: "float-right" }, [
                            _c("i", {
                              staticClass: "fas fa-share",
                              attrs: { title: _vm.$t("txtShared") }
                            })
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col no-overflow",
                        staticStyle: {
                          "margin-left": "-0.5rem",
                          "margin-right": "-0.5rem"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-row align-items-center" },
                          [
                            _vm.card.description
                              ? _c("i", {
                                  staticClass: "fas fa-align-left mx-2"
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.card.taskItems && _vm.card.taskItems.length
                              ? _c("div", { staticClass: "mx-2 d-inline" }, [
                                  _c("i", {
                                    staticClass: "far fa-check-square"
                                  }),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.card.taskItems.filter(
                                          t => t.status === "DONE"
                                        ).length +
                                          "/" +
                                          _vm.card.taskItems.length
                                      ) +
                                      "\n              "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.card.comments && _vm.card.comments.length === 1
                              ? _c("i", { staticClass: "fas fa-comment mx-2" })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.card.comments && _vm.card.comments.length > 1
                              ? _c("i", { staticClass: "fas fa-comments mx-2" })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.card.responsibles &&
                            _vm.card.responsibles.length === 1
                              ? _c("i", { staticClass: "fas fa-user mx-2" })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.card.responsibles &&
                            _vm.card.responsibles.length > 2
                              ? _c("i", { staticClass: "fas fa-users mx-2" })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.card.dueDate
                              ? _c("i", {
                                  staticClass: "far fa-calendar-alt mx-2"
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            !!_vm.card.activityId
                              ? _c("LinkedActivityCheckableIcon", {
                                  staticClass: "mx-2",
                                  attrs: {
                                    checked: _vm.isActivityClosed(
                                      _vm.card.activityId
                                    )
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "ml-auto",
                                style: { color: _vm.dueDateColor }
                              },
                              [_vm._v(_vm._s(_vm.dueDateShort))]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ])
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }